import { TableCell } from '@tiptap/extension-table-cell';
import { mergeAttributes } from '@tiptap/core';

/**
 * Extended TableCell with vertical alignment support
 */
export const TableCellExtended = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            verticalAlign: {
                default: 'top',
                parseHTML: (element) => element.getAttribute('data-vertical-align') || 'top',
                renderHTML: (attributes) => {
                    if (!attributes.verticalAlign) {
                        return {};
                    }
                    return {
                        'data-vertical-align': attributes.verticalAlign,
                        style: `vertical-align: ${attributes.verticalAlign};`,
                    };
                },
            },
        };
    },
});
